<template>
  <section class="gallery-section">
    <h2 v-if="header">{{ $t(header) }}</h2>
    <div class="gallery-section-img-container">
      <img v-for="(photo, idx) in photos" width="302" height="220" :key="idx" :src="imageUrlWithProxy((photo as any).url, 548, 220, 'fit')" :alt="(photo as any).description" loading="lazy" @click="$emit('imageClick', idx)">
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  header: {type: String, required: false},
  photos: {type: Array, default: [], required: true},
})

defineEmits<{
  imageClick: [index: number]
}>()

import { imageUrlWithProxy } from '../../utils/imageproxy'
</script>

<style scoped lang="scss">

.gallery-section {
  color: var(--black);

  h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 8px;
    padding-top: 16px;
  }

  .gallery-section-img-container {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    img {
      border-radius: 8px;
      object-fit: cover;
      max-height: 220px;
      cursor: pointer;

      @media (max-width: 768px) {
        width: 100%;
        max-height: 220px;
      }
    }
  }
}

</style>
